export default function AboutSection() {
  return (
    <section id="about" className="w-full py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-4xl mx-auto">
        <div className="flex items-center gap-3 mb-10">
          <span className="w-1 h-6 bg-secondary-500 rounded-full"></span>
          <h2 className="text-foreground-900 font-heading text-2xl md:text-3xl font-bold">
            关于我们
          </h2>
        </div>

        <div className="bg-background-50 rounded-xl p-6 md:p-10 border border-background-200/60">
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            哈哈影院成立于 2020 年，是一家专注于高清免费在线影视的服务平台。我们秉持「观影无门槛，精彩不等待」的理念，致力于为全球华语用户提供最丰富的影视资源与最流畅的播放体验。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed mb-4">
            平台目前已收录超过十万部影视作品，涵盖电影、电视剧、综艺、动漫、纪录片等全品类内容。我们的技术团队持续优化播放引擎与 CDN 加速网络，确保每一位用户都能随时随地畅享高清不缓冲的观影体验。
          </p>
          <p className="text-foreground-600 text-sm md:text-base leading-relaxed">
            哈哈影院坚持免费开放策略，不设付费墙、不强制注册，让好内容触手可及。未来我们将继续拓展资源库、优化产品体验，力争成为您最信赖的在线观影伙伴。
          </p>

          <div className="flex flex-wrap gap-6 mt-8 pt-6 border-t border-background-200/40">
            <div className="text-center">
              <p className="text-accent-500 font-heading text-xl md:text-2xl font-bold">2020</p>
              <p className="text-foreground-500 text-xs mt-1">创立年份</p>
            </div>
            <div className="text-center">
              <p className="text-accent-500 font-heading text-xl md:text-2xl font-bold">10万+</p>
              <p className="text-foreground-500 text-xs mt-1">影视资源</p>
            </div>
            <div className="text-center">
              <p className="text-accent-500 font-heading text-xl md:text-2xl font-bold">500万+</p>
              <p className="text-foreground-500 text-xs mt-1">月活用户</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}